import React from "react"

export const Dish: React.FC<{ size?: number }> = ({ size = 48 }) => (
  <svg
    enable-background='new 0 0 24 24'
    height={`${size}px`}
    width={`${size}px`}
    id='Layer_1'
    version='1.1'
    viewBox='0 0 24 24'
    xmlSpace='preserve'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g>
      <path d='M0,23c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-1H0V23z' />
      <path d='M22,20h2c0-6.3-4.8-11.4-11-11.9V7h1c0.6,0,1-0.4,1-1s-0.4-1-1-1h-4C9.4,5,9,5.4,9,6s0.4,1,1,1h1v1.1C4.8,8.6,0,13.7,0,20   h2H22z M12,10c4.8,0,8.9,3.4,9.8,8H2.2C3.1,13.4,7.2,10,12,10z' />
      <path d='M16.5,12.2L16,13.1c1.5,0.9,2.7,2.2,3.4,3.8l0.9-0.4C19.6,14.7,18.2,13.2,16.5,12.2z' />
    </g>
  </svg>
)
